module.exports = __webpack_public_path__ + "static/media/Identity.0426799c.jpeg";